(function($) {
    $.fn.countTo = function(options) {
        options = $.extend({}, $.fn.countTo.defaults, options || {});

        var loops = Math.ceil(options.speed / options.refreshInterval),
            increment = (options.to - options.from) / loops;

        return $(this).each(function() {
            var _this = this,
                loopCount = 0,
                value = options.from,
                interval = setInterval(updateTimer, options.refreshInterval);

            function updateTimer() {
                value += increment;
                loopCount++;
                if ( $(_this).hasClass('has-comma') ) {
	                $(_this).html(value.toFixed(options.decimals).toString().replace(".", ","));
                } else {
	                $(_this).html(value.toFixed(options.decimals));
                }

                if (typeof(options.onUpdate) == 'function') {
                    options.onUpdate.call(_this, value);
                }

                if (loopCount >= loops) {
                    clearInterval(interval);
                    value = options.to;

                    if (typeof(options.onComplete) == 'function') {
                        options.onComplete.call(_this, value);
                    }
                }
            }
        });
    };

    jQuery(function($) {
        $('.item-stat-number.count').each(function(){
            $(this).countTo({
                from: 0,
                to: $(this).html().replace(",", "."),
                speed: 500,
                decimals: $(this).hasClass("simple") ? 0 : $(this).hasClass("single") ? 1 : $(this).hasClass("multiple") ? 3 : 2,
                refreshInterval: 50
            });
        });
    });
})(jQuery);
